var _rect, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 4.8,
    width: 16.4,
    height: 19.4,
    rx: 2.2,
    stroke: "white",
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 8.625,
    x2: 20.625,
    y2: 8.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 13.625,
    x2: 20.625,
    y2: 13.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 18.625,
    x2: 20.625,
    y2: 18.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 9.625,
    x2: 17.625,
    y2: 9.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 14.625,
    x2: 17.625,
    y2: 14.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15.375,
    y1: 19.625,
    x2: 17.625,
    y2: 19.625,
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26563 8.23437L10.0329 9.42236C10.1365 9.58289 10.3619 9.60687 10.497 9.47174L12.7344 7.23437",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26563 13.2344L10.0329 14.4224C10.1365 14.5829 10.3619 14.6069 10.497 14.4717L12.7344 12.2344",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26563 18.2344L10.0329 19.4224C10.1365 19.5829 10.3619 19.6069 10.497 19.4717L12.7344 17.2344",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.2222V21.9753L20.7948 20L24.9998 21.3827C24.7947 22.9959 24.9998 26.2222 24.9998 26.2222C24.9998 26.2222 22.4016 27.4074 20.7948 28L17 26.2222Z",
    fill: "#78A6BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.9753V26.2222L20.7948 28M17 21.9753C18.47 22.5679 21.3896 23.8519 20.8973 23.8519M17 21.9753L20.7948 20L24.9998 21.3827M20.7948 28C22.4016 27.4074 24.9998 26.2222 24.9998 26.2222C24.9998 26.2222 24.7947 22.9959 24.9998 21.3827M20.7948 28L20.8973 23.8519M24.9998 21.3827C23.393 22.1728 20.405 23.8519 20.8973 23.8519",
    stroke: "white",
    strokeWidth: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.8889V23.2346L15.3718 22L18 22.8642C17.8718 23.8724 18 25.8889 18 25.8889C18 25.8889 16.3761 26.6296 15.3718 27L13 25.8889Z",
    fill: "#78A6BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.2346V25.8889L15.3718 27M13 23.2346C13.9188 23.6049 15.7436 24.4074 15.4359 24.4074M13 23.2346L15.3718 22L18 22.8642M15.3718 27C16.3761 26.6296 18 25.8889 18 25.8889C18 25.8889 17.8718 23.8724 18 22.8642M15.3718 27L15.4359 24.4074M18 22.8642C16.9957 23.358 15.1282 24.4074 15.4359 24.4074",
    stroke: "white",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.f5fd458e6ab2a65564934986984ac6ea.svg";
export { ForwardRef as ReactComponent };